import { combineReducers } from 'redux'
import list from './list.store'
import current from './current.store'
import previewLineItem from './preview-line-item.store'
import refund from './refund.store'

export const rootReducer = combineReducers({
  list,
  current,
  previewLineItem,
  refund,
})
